import { ReactElement, useCallback } from 'react';

import { NavigationListProps, NavigationItemEvent } from './types';
import NavigationListItem from './ListItem';
import { NavigationListContainer } from './styles';

const NavigationList = ({
  items,
  activeItem,
  onClickItem,
}: NavigationListProps): ReactElement => {
  const getIsActiveCurrenItem = useCallback(
    (currentItem: NavigationItemEvent) =>
      activeItem === currentItem.id || activeItem === currentItem.path,
    [activeItem],
  );

  return (
    <NavigationListContainer>
      {items.map(
        ({ enabled = true, ...item }) =>
          enabled && (
            <NavigationListItem
              key={`navigation-list-item-${item.id}`}
              isActive={getIsActiveCurrenItem(item)}
              onClick={onClickItem}
              {...item}
            />
          ),
      )}
    </NavigationListContainer>
  );
};

export default NavigationList;
